import React from 'react'
import { graphql } from 'gatsby'
import Helmet from 'react-helmet'
// import get from 'lodash/get'
import Layout from '../components/layout'
import Img from 'gatsby-image'

class BlogTemplate extends React.Component {
  render() {
    const post = this.props.data.markdownRemark
    var image = post.frontmatter.cover_image.publicURL
    var color = 'rgb(211, 232, 225)'
    var title = post.frontmatter.title
    var description = post.frontmatter.description

    return (
      <Layout location={this.props.location} style={{ backgroundColor: color }}>
        <Helmet
          title={title}
          meta={[
            {
              name: 'title',
              content: title,
            },
            {
              name: 'description',
              content: description,
            },

            { property: 'og:title', content: title },

            {
              property: 'og:description',
              content: description,
            },
            {
              property: 'og:image',
              content: this.props.data.site.siteMetadata.url + image,
            },
            {
              name: 'twitter:creator',
              content: 'DiversifyTechCo',
            },
            {
              name: 'twitter:title',
              content: title,
            },
            {
              name: 'twitter:description',
              content: description,
            },
            { name: 'twitter:card', content: 'summary_large_image' },
            {
              name: 'twitter:image',
              content: this.props.data.site.siteMetadata.url + image,
            },
          ]}
        >
          <html lang="en" />
        </Helmet>

        <div
          className="p-6"
          style={{ backgroundColor: color, maxWidth: '100%' }}
        >
          <div className="text-xl">
            <span className="pr-2">
              <a className="text-black" href="/blog">
                Blog
              </a>
            </span>
            /<span className="pl-2">{title}</span>
          </div>
        </div>

        <div className="p-6 blog-post">
          <div className="pb-4 flex w-full">
            <div className="h-full w-full border rounded border-light-grey bg-white">
              <Img fluid={post.frontmatter.cover_image.childImageSharp.fluid} />
              <p className="text-center text-grey">
                {post.frontmatter.image_credit}
              </p>
              <div className="p-6 leading-normal mx-auto max-w-screen-md">
                <h1>{post.frontmatter.title}</h1>
                <p className="text-grey-dark pb-4">{post.frontmatter.date}</p>
                <div
                  className="blog-post-content"
                  dangerouslySetInnerHTML={{ __html: post.html }}
                />
              </div>
            </div>
          </div>
        </div>
      </Layout>
    )
  }
}

export default BlogTemplate

export const pageQuery = graphql`
  query($path: String!) {
    site {
      siteMetadata {
        title
        url
      }
    }

    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        path
        title
        image_credit
        cover_image {
          publicURL
          childImageSharp {
            fluid(maxWidth: 1000) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`
